import {validatePayload} from '../../../../utils/validate-payload.js';
import {type LegacySearchAction, makeAnalyticsAction} from '../../../analytics/analytics-utils.js';
import {
  getRangeFacetMetadata,
  rangeBreadcrumbFacet,
} from '../generic/range-facet-analytics-actions.js';
import {rangeFacetSelectionPayloadDefinition} from '../generic/range-facet-validate-payload.js';
import type {DateFacetValue} from './interfaces/response.js';

export interface LogDateFacetBreadcrumbActionCreatorPayload {
  /**
   * The facet id of the date facet corresponding to the breadcrumb.
   */
  facetId: string;

  /**
   * The date facet value deselected using the breadcrumb.
   */
  selection: DateFacetValue;
}

//TODO: KIT-2859
export const logDateFacetBreadcrumb = (
  payload: LogDateFacetBreadcrumbActionCreatorPayload
): LegacySearchAction =>
  makeAnalyticsAction('analytics/dateFacet/breadcrumb', (client, state) => {
    validatePayload(payload, rangeFacetSelectionPayloadDefinition(payload.selection));
    const metadata = getRangeFacetMetadata(state, payload);

    return client.makeBreadcrumbFacet(metadata);
  });

export const dateBreadcrumbFacet = rangeBreadcrumbFacet;
